import { useState } from 'react'

import {
  UseRowSelection,
  UseRowSelectionParams,
  ValidRowSelection,
} from './use-row-selection'

const useRowSelection = (params?: UseRowSelectionParams): UseRowSelection => {
  const [selectedRows, setSelectedRows] = useState<ValidRowSelection>(
    params?.initialSelection ?? [],
  )

  return {
    selectedRows,
    setSelectedRows,
  }
}

export default useRowSelection
